import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import TelecomLinkBoxRow from '../../components/TelecomLinkBoxRow';

export type IFT_011_2022_pt_3Props = {};

const IFT_011_2022_pt_3: React.FC<IFT_011_2022_pt_3Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "telecommunications",
          defaultMessage: "Telecommunications"
        })}
        subHeading='IFT-011-2022:'
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="w-full">
          <h2 className='text-xl text-secondary font-bold mb-2'>
            IFT-011-2022
          </h2>
          <p>
            {
              intl.formatMessage({
                id: "tech_spec_cell",
                defaultMessage: "Technical Specifications of Mobile Terminal Equipment that can make use of the radio spectrum or be connected to telecommunications networks. Part 3. Cellular Broadcasting Service for notification of Risk or Emergency situations."
              })
            }
          </p>
        </div>
        <div className="flex w-full flex-col md:flex-row items-center justify-center">
          <div className="flex flex-col w-full md:w-7/12 lg:w-10/12 pt-0 md:pt-6 pb-10 md:pb-0 gap-10">
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'scope',
                    defaultMessage: "Scope:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "cell_scope_1",
                    defaultMessage: "This Technical Provision is applicable to all Mobile Terminal Equipment (cell phones and/or smartphones) that can make use of the radio spectrum or be connected to telecommunications networks, for the reception and processing of Risk Alert Messages or Emergency Situations. Emergency through the Cellular Broadcasting Service."
                  })
                }
              </p>
              <p>
                {
                  intl.formatMessage({
                    id: "cell_scope_2",
                    defaultMessage: "Mobile Terminal Equipment that is using international roaming within the national territory, as well as smart watches that have a SIM or eSIM, and are compatible with the Cellular Broadcasting Service, are exempt. Said smart watches may receive and process some form of Alert Messages and, given their technical characteristics, the display of said alert messages, the audible signal and the vibration cadence may be different from those received and processed by cell phones and/or or smartphones, their operation will not be limited."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'products_terminal_example',
                    defaultMessage: "Examples of equipment subject to compliance with the NOM:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "cell_scope_3",
                    defaultMessage: "Cell phones or smartphones"
                  })
                }
              </p>
            </div>
          </div>
          <div className=" flex items-center justify-center w-full md:w-5/12 lg:w-4/12 pt-8">
            <img src="/img/mobile-phone.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default IFT_011_2022_pt_3;